export const tw = {
  'already_logout': '已登出，請再次登入',
  'logout': '登出',
  'user_login': '登入學習系統',
  'username': '帳號',
  'password': '密碼',
  'login': '登入帳號',
  'hide_video': '收合影片',
  'view_video': '展開影片',
  'slow_audio_playback': '慢速音檔播放中',
  'video_transcript': '課程文章',
  'wordbank': '課程單字',
  'highlights': '課程重點',
  'slow_playback': '慢速',
  'view_translation': '翻譯',
  'dictionary': '字典',
  'fill_in_the_blanks': '聽力填空',
  'multiple_choice': '聽力理解',
  'complete_the_sentence': '翻譯填空',
  'unscramble_the_sentences': '句子重組',
  'the_assessment_begin_description': '您即將開始進行能力檢測。本能力檢測依照：聽力、字彙片語、文法句型、閱讀分為四個部分，每個部分約為12-16題，題目的難易度會依照答題的正確率而調整。',
  'start_test': '開始測驗',
  'next': '下一題',
  'assessment_completed_description': '恭喜您已經完成能力檢測！',
  'recommendation_according_assessment_result': '本系統將依據您的檢測結果，提供您推薦課程。您可以點選看分析查看剛才的考試結果，或是點選推薦課程，開始觀看線上課程。',
  'view_result': '看分析',
  'my_recommendation': '推薦課程',
  'view_assessment_history': '檢視過去能力紀錄',
  'assessment': '開始能力檢測',
  'view_recommendation': '前往推薦課程',
  'assessment_history': '歷史紀錄',
  'view_list': '顯示清單',
  'detail': '查看',
  'assessment_test': '能力檢測',
  'listening_skill': '聽力能力',
  'reading_skill': '閱讀能力',
  'vocabulary_skill': '單字能力',
  'grammar_skill': '文法能力',
  'test_date': '測驗日期',
  'period': '考試日期',
  'title': '考試名稱',
  'assigned_by': '指派老師',
  'listening': '聽力',
  'reading': '閱讀',
  'total': '總分',
  'status': '通過',
  'take_test': '功能',
  'n_a': '無',
  'not_released': '未開放',
  'test_is_over': '已結束',
  'go_test': '考試',
  'completed': '已完成',
  'no_test_found': '目前無考試資料',
  'my_test': '考試作業',
  'new_test': '新增考試',
  'added_on': '建立日期',
  'assisgnment_history': '指派清單',
  'assign': '指派',
  'edit': '編輯',
  'view_score': '檢視成績',
  'delete': '刪除',
  'assignment_deleting_notice': '考試指派中，若刪除清單，紀錄會一併刪除。',
  'deleting_confirm': '確定要刪除？',
  'yes': '確認',
  'cancel': '取消',
  'has_been_assigned_to': '已經指派給',
  'no_assignment_has_been_made': '目前無指派資訊',
  'deleting_assignment_confirm': '確定要刪除指派？',
  'assign_to': '您要指派 [{msg}] 給',
  'no_class_is_assigned': '目前無班級資訊',
  'submit_assign': '確認指派',
  'set_duration_of': '設定 [{msg}] 的指派時間',
  'class': '班級',
  'from': '開始時間',
  'to': '結束時間',
  'test_result_of': '檢視 [{msg}] 的指派班級成績',
  'more': '詳細內容',
  'please_check_time_format': '請檢查時間格式有無正確',
  'please_enter_valid_datetime': '指派時間錯誤',
  'replace': '更新考試',
  'add_test': '建立考試',
  'select': '選擇試卷',
  'test': '試卷名稱',
  'level': '級別',
  'time_used': '使用次數',
  'preview': '預覽試卷',
  'download': '預覽',
  'please_name_this_test': '考試名稱不得為空白',
  'please_choose_a_test': '需選擇試卷',
  'finish': '交卷',
  'test_completed': '完成考試',
  'class_name': '班級名稱',
  'teacher': '指導老師',
  'list_of_students': '學生名單',
  'edit_list': '編輯名單',
  'edit_class': '編輯班級',
  'add_class': '新增班級',
  'import_class_information': '匯入班級',
  'export_all_classes': '匯出全部班級',
  'download_list_of_class': '下載班級清單',
  'no_class_found': '目前無任何班級',
  'file': '檔案',
  'download_template': '範本下載',
  'class_management': '班級管理',
  'class_information': '班級資料',
  'import_list_of_students': '匯入學生名單',
  'add_current_student': '從現有學生新增',
  'add_new': '單筆新增',
  'remove': '移除',
  'add': '加入',
  'at_least_4_characters': '需大於四位數',
  'name': '姓名',
  'student_id': '學號',
  'no_assignment_found': '目前無任何課程作業',
  'please_enter_course_name': '請輸入課程名稱...',
  'update': '更新課程',
  'add_course': '建立課程',
  'course_category': '課程類別',
  'daily_english': '生活類課程',
  'travel_shopping_english': '旅遊類課程',
  'course_level': '課程級別',
  'show_selected': '已選擇課程',
  'show_unselected': '未選擇課程',
  'course_has_not_been_saved_notice': '您並未儲存課程，關閉後資料將會遺失。',
  'please_name_this_course': '課程名稱不得為空白',
  'please_choose_course': '需選擇課程',
  'no_course_found': '目前無任何課程',
  'my_favorites': '我的最愛',
  'all_courses': '課程清單',
  'new_course': '新增課程',
  'course_assignment_deleting_confirm': '課程指派中，若刪除清單，學習紀錄會一併刪除。',
  'add_recourse': '新增資源',
  'keyword': '關鍵字',
  'search': '搜尋',
  'show_my_uploads_only': '只顯示我的檔案',
  'view': '查閱',
  'upload_files': '上傳檔案',
  'file_formats': '檔案上傳格式限制',
  'picture_format_required': '圖片：jpg, png (最大2M)',
  'video_format_required': '影片：mp4 (最大25M)',
  'audio_format_required': '聲音：mp3 (最大25M)',
  'online_resources_management': '資源管理',
  'please_choose_a_file': '請選擇檔案',
  'by_course': '課程紀錄列表',
  'by_assignment': '課程作業紀錄',
  'by_test': '考試成績列表',
  'no_result_found': '目前無資料',
  'score': '班級成績',
  'class_performance': '全班平均',
  'view_individual': '學生成績',
  'individual_student': '學生成績名單',
  'statistics': '個人成績',
  'assignment': '課程作業',
  'test_history': '考試歷程',
  'not_taken': '未考',
  'view_details': '查閱紀錄',
  'test_assigned': '指派考試',
  'score_management': '成績管理',
  'video': '影片',
  'transcript': '文字',
  'quiz': '測驗',
  'all': '全部',
  'times': '次數',
  'interactive': '互動',
  'type': '類型',
  'percentage': '比率',
  'category': '主題排行',
  'top_courses': '單元排行',
  'course_reports': '課程統計',
  'no_report_found': '目前無任何學習紀錄',
  'learning_record': '學習紀錄',
  'email': '電子信箱',
  'add_student': '新增學生',
  'import': '匯入名單',
  'export': '匯出名單',
  'no_student_found': '目前無任何學生',
  'student_management': '學生管理',
  'complete_list_of_students': '全部學生名單',
  'add_teacher': '新增老師',
  'no_teacher_found': '目前無任何老師',
  'teacher_management': '老師管理',
  'complete_list_of_teachers': '全部老師名單',
  'online_resources': '線上資源',
  'message': '訊息',
  'history': '歷史紀錄',
  'learning_record_mgr': '成績管理'
}



// WEBPACK FOOTER //
// ./src/locales/zh_tw.js